import { useMutation, useQuery } from '@tanstack/react-query'
import { getCommonContent, getQuestions, fillContactUsForm } from '../api/common'

export const useGetCommonContentQuery = (queryParams = '') => {
    return useQuery({
        queryKey: ['common_content', queryParams],
        queryFn: () => getCommonContent(queryParams),
        enabled: !!queryParams
    });
};

export const useGetFAQQuery = (queryParams = '') => {
    return useQuery({
        queryKey: ['faqs', queryParams],
        queryFn: () => getQuestions(queryParams),
        enabled: !!queryParams
    });
};

export const useFillContactUsForm = () => {
    return useMutation({
        mutationFn: fillContactUsForm
    })
};